import React, { useRef, useState, useEffect } from "react";
import styles from "./ImageInputJZWIT.module.sass";
import cn from "classnames";
import Card from "components/Card";
import Tooltip from "components/Tooltip";
import Icon from "components/Icon";
import { validateImage } from "utils/validation";
import { fileSizes } from "data/dataArrays";
import useAuth from 'hooks/useAuth';

const ImageInputJZWIT = ({
  className,
  label,
  tooltip,
  title,
  img,
  setFile,
  onDelete,
  fileName,
  cropperHeight,
  isEditor,
  // onImageChange
}) => {
  const authCtx = useAuth();
  const inputRef = useRef();
  // image is IMAGEbase64 used to display on screen
  const [image, setImage] = useState(img || null);
  const [imageUpdated,setImageUpdated] = useState(false)
  const [cropperData, setCropperData] = useState({
    visible: false,
    image: null,
    width: 0,
    height: 0,
    filename: "",
  });

  const onFileChange = (e) => {
    const file = e.target.files[0];

    setFile(file)
    setImage(URL.createObjectURL(file))
  };

  const handleClick = () => {
    inputRef.current.click();
  };

  useEffect(() => {
    if(isEditor)
    {
      if(!imageUpdated && img)
      {
        setImage(img)
        setImageUpdated(true)
      }
    }
  }, [img]);

  const handleDelete = () => {
    setImage(null);
    setFile(null);
    onDelete && onDelete();
  };


  return (
    <>
      <Card
        className={cn(styles.card, className)}
        title={title}
        classTitle="title-blue"
      >
        <div className={styles.images}>
          <div className={cn(styles.file, className)}>
            {label && (
              <div className={styles.label}>
                {label}{" "}
                {tooltip && (
                  <Tooltip
                    className={styles.tooltip}
                    title={tooltip}
                    icon="info"
                    place="right"
                  />
                )}
              </div>
            )}
            <div className={styles.wrap}>
              {image && <img src={image} alt="Obraz" />}
              <input
                className={styles.input}
                type="file"
                accept="image/*"
                ref={inputRef}
                onChange={onFileChange}
              />
              {image ? (
                <div className={styles.box} onClick={handleDelete}>
                  <Icon name="trash" size="24" />
                  Usuń
                </div>
              ) : (
                <div className={styles.box} onClick={handleClick}>
                  <Icon name="upload" size="24" />
                  Prześlij obraz
                </div>
              )}
            </div>
          </div>
        </div>
      </Card>
    </>
  );
};
export default ImageInputJZWIT;
